import { useState } from "react";
import { loadDraft } from "@/hooks/workflowDraft";

export const emptyPatient = {
  name: "", age: "", sex: "", chief_complaint: "", symptoms: "", duration: "",
  past_history: "", weight: "", obstetric_history: "", vaccination_history: "",
};

export const emptyFindings = { examination_notes: "", vitals: {} };

// Owns every piece of workflow state and restores any autosaved draft.
export function useWorkflowState() {
  const saved = loadDraft();
  const hadSavedDraft = Boolean(
    saved && ((saved.step ?? 0) > 0 || (saved.patient && (saved.patient.chief_complaint || saved.patient.symptoms)))
  );
  const [model, setModel] = useState(saved.model || "claude-sonnet-5-5");
  const [step, setStep] = useState(saved.step ?? 0);
  const [loading, setLoading] = useState("");
  const [patient, setPatient] = useState(saved.patient || emptyPatient);
  const [questions, setQuestions] = useState(saved.questions ?? null);
  const [answers, setAnswers] = useState(saved.answers || {});
  const [tentative, setTentative] = useState(saved.tentative ?? null);
  const [signs, setSigns] = useState(saved.signs ?? null);
  const [signResp, setSignResp] = useState(saved.signResp || {});
  const [findings, setFindings] = useState(saved.findings || emptyFindings);
  const [scores, setScores] = useState(saved.scores ?? null);
  const [differentials, setDifferentials] = useState(saved.differentials ?? null);
  const [investigations, setInvestigations] = useState(saved.investigations ?? null);
  const [reports, setReports] = useState(saved.reports || []);
  const [imaging, setImaging] = useState(saved.imaging || []);
  const [final, setFinal] = useState(saved.final ?? null);
  const [answersReminded, setAnswersReminded] = useState(false);
  const [signsReminded, setSignsReminded] = useState(false);

  return {
    model, setModel, step, setStep, loading, setLoading,
    patient, setPatient, questions, setQuestions, answers, setAnswers,
    tentative, setTentative, signs, setSigns, signResp, setSignResp,
    findings, setFindings, scores, setScores, differentials, setDifferentials,
    investigations, setInvestigations, reports, setReports, imaging, setImaging,
    final, setFinal, answersReminded, setAnswersReminded, signsReminded, setSignsReminded,
    hadSavedDraft,
  };
}
